import React from "react";
import TableCard from "../../shared/TableCard/TableCard";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import TableImage from "../../shared/TableCard/TableImage";
import { FilterMatchMode, FilterOperator } from "primereact/api";

export default function ServiceTable({ heading, allServices, loading, history, search, setSearch, onDelete, selection = false }) {
    const actions = (d) => {
        return (
            <div className="flex justify-content-around gap-1">
                <i className="pi pi-eye cursor-pointer" onClick={() => history.push(`/services/view/${d._id}`)}></i>
                <i className="pi pi-pencil cursor-pointer" onClick={() => history.push(`/services/edit/${d._id}`)}></i>
                <i className="pi pi-trash cursor-pointer" onClick={(e) => onDelete(e, d)}></i>
            </div>
        );
    };

    const image = (r) => {
        const image = r.iconImage;
        return <TableImage image={image} />;
    };

    const filters = {
        time: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        subscriptionExpireOn: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    };
    const formatDate = (date) => {
        return new Date(date).toLocaleDateString("en-US", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });
    };

    return (
        <>
            <TableCard title={heading} onSearch={setSearch} searchKeyword={search} buttonTitle="Add Service" linkTo={`/services/add`}>
                <DataTable
                    paginator
                    value={allServices}
                    selectionMode="checkbox"
                    showGridlines
                    filter={filters}
                    filterDisplay="menu"
                    rows={10}
                    loading={loading}
                    emptyMessage="No service found."
                >
                    <Column body={image} header="Icon" style={{ width: "80px" }}></Column>
                    <Column body={(rowData) => rowData.serviceName} header="Name"></Column>
                    <Column field="description" header="Description"></Column>
                    <Column field="createdAt" body={(r) => formatDate(r.time)} header="Created At"></Column>
                    <Column body={actions} style={{ width: "100px" }} header="Action"></Column>
                </DataTable>
            </TableCard>
        </>
    );
}
